/**
 * Mobile Side Tab Scroll-Based Reveal for Idea to Icon
 * Progressively reveals the tab as user scrolls and product title approaches viewport top
 */

(function() {
  'use strict';

  // Configuration
  const CONFIG = {
    REVEAL_START_DISTANCE: 500,  // Distance from top (px) when reveal starts
    REVEAL_END_DISTANCE: 150,    // Distance from top (px) when fully revealed
    MIN_TRANSLATEX: 0,           // Fully revealed position (px)
    MAX_TRANSLATEX: 135,         // Fully retracted position (px)
  };

  let mobileButton = null;
  let productTitleContainer = null;
  let ticking = false;

  // Initialize when DOM is ready
  function init() {
    mobileButton = document.querySelector('.idea-to-icon-trigger-mobile');
    
    if (!mobileButton) return;

    // Only run on mobile screens
    if (window.innerWidth >= 700) {
      mobileButton.style.display = 'none';
      return;
    }

    // Find the product title container (parent div of the button)
    // The button is inside an h-stack div, so we use that as our reference
    productTitleContainer = mobileButton.closest('.h-stack');

    if (!productTitleContainer) return;

    // Set up scroll listener
    window.addEventListener('scroll', onScroll, { passive: true });
    
    // Initial calculation
    updateButtonPosition();
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        updateButtonPosition();
        ticking = false;
      });
      ticking = true;
    }
  }

  function updateButtonPosition() {
    if (!productTitleContainer || !mobileButton) return;

    // Get the distance of the title container from the top of the viewport
    const rect = productTitleContainer.getBoundingClientRect();
    const distanceFromTop = rect.top;

    // Calculate reveal percentage (0 = retracted, 1 = fully revealed)
    let revealPercentage = 0;
    
    if (distanceFromTop <= CONFIG.REVEAL_START_DISTANCE) {
      if (distanceFromTop <= CONFIG.REVEAL_END_DISTANCE) {
        revealPercentage = 1; // Fully revealed
      } else {
        // Calculate percentage between start and end
        revealPercentage = 1 - (distanceFromTop - CONFIG.REVEAL_END_DISTANCE) / 
                              (CONFIG.REVEAL_START_DISTANCE - CONFIG.REVEAL_END_DISTANCE);
      }
    }

    // Calculate translateX value (135px retracted -> 0px revealed)
    const translateX = CONFIG.MAX_TRANSLATEX - (revealPercentage * (CONFIG.MAX_TRANSLATEX - CONFIG.MIN_TRANSLATEX));
    
    // Apply transform using translate3d for GPU acceleration and smoother performance
    mobileButton.style.transform = `translate3d(${translateX}px, -50%, 0)`;

    // Hide completely if scrolled past the product section
    if (distanceFromTop < -600) { // Adjust this value based on your layout
      mobileButton.style.opacity = '0';
      mobileButton.style.pointerEvents = 'none';
    } else {
      mobileButton.style.opacity = '1';
      mobileButton.style.pointerEvents = 'auto';
    }
  }

  // Run init when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Handle window resize
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      if (!mobileButton) return;

      if (window.innerWidth >= 700) {
        mobileButton.style.display = 'none';
      } else {
        mobileButton.style.display = 'flex';
        updateButtonPosition(); // Recalculate on resize
      }
    }, 250);
  });
})();
